import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, watch } from 'vue';
    import { debounce } from 'lodash';
    import Suggestions from './Suggestions.vue';
    import useClickOutside from 'vueCommon/composables/useClickOutside';
    import SpinnerSvg from 'vueCommon/ui/SpinnerSvg.vue';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'Input',
  props: {
        suggestions: {
            type: Array,
            default: () => {
                return [];
            },
        },
        classes: {
            type: Array,
            default: () => {
                return ['form-control'];
            },
        },
        optionAutocomplete: {
            default: 'off',
            type: String,
        },
        optionAutocorrect: {
            default: 'off',
            type: String,
        },
        optionAutocapitalize: {
            default: 'off',
            type: String,
        },
        timeoutDebounce: {
            default: 1000,
            type: Number,
        },
        minLength: {
            default: 1,
            type: Number,
        },
        process: {
            default: false,
            type: Boolean,
        },
        placeholder: {
            type: String,
            default: '',
        },
        defaultValue: {
            default: '',
            type: String,
        },
        label: {
            default: '',
            type: String,
        },
    },
  emits: [
        'handleLazyKeyup',
        'handleFocus',
        'handleBlur',
        'handlePaste',
        'handleSetSuggestion',
        'handleChange',
    ],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

    const emit = __emit;

    const props = __props;

    const query = ref<String>('');
    const showSuggestions = ref<Boolean>(false);
    const focusState = ref<Boolean>(false);
    const componentRef = ref();
    const excludeRef = ref();

    const canShowSuggestions = computed(() => {
        return props.suggestions.length > 0 && showSuggestions.value;
    });

    watch(
        () => props.defaultValue,
        (newDefaultValue, oldDefaultValue) => {
            if (newDefaultValue && !oldDefaultValue && !query.value) {
                query.value = newDefaultValue;
            }

            if (
                newDefaultValue &&
                oldDefaultValue &&
                newDefaultValue !== oldDefaultValue
            ) {
                query.value = newDefaultValue;
            }

            /**
             * @doc удаление из родительского компонента
             */
            if (!newDefaultValue && oldDefaultValue) {
                query.value = '';
            }
        }
    );

    useClickOutside(
        componentRef,
        () => {
            showSuggestions.value = false;
        },
        excludeRef
    );

    const handleFocus = (e) => {
        focusState.value = true;
        emit('handleFocus', e);
    };

    const handleBlur = (e) => {
        focusState.value = false;
        /**
         * @doc Нельзя сбивать новым запросом уже выпадший список через событие Blur
         * иначе начинаются неприятные эффекты в связке с handleChange
         */
        if (showSuggestions.value) {
            return;
        }

        emit('handleBlur', e);
        lazyAutocomplete(e.target.value);
    };

    const handleChangeValue = (e) => {
        emit('handleChange', e.target.value);
        lazyAutocomplete(e.target.value);
    };

    const setSuggestion = (suggestion) => {
        emit('handleSetSuggestion', suggestion);
        showSuggestions.value = false;
        query.value = suggestion.mainValue;
    };

    const lazyAutocomplete = debounce((value) => {
        if (props.minLength > value.length) {
            return;
        }

        showSuggestions.value = true;
        emit('handleLazyKeyup', value);
    }, props.timeoutDebounce);

const __returned__ = { emit, props, query, showSuggestions, focusState, componentRef, excludeRef, canShowSuggestions, handleFocus, handleBlur, handleChangeValue, setSuggestion, lazyAutocomplete, Suggestions, SpinnerSvg }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})